import React from 'react';
import {
    Box,
    Button,
    Divider,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import { SortType, TypeFilter } from '../../../types';
import MobileBottomDrawer from './MobileBottomDrawer';

const label = (text: string) => <Typography variant="body1">{text}</Typography>;

type MobileSortViewDrawerProps = {
    open: boolean;
    onClose: () => void;
    sortType: SortType;
    onSelectSortType: (sortType: SortType) => void;
    typeFilter: TypeFilter;
    onSelectTypeFilter: (typeFilter: TypeFilter) => void;
    onDone: () => void;
};

const MobileSortViewDrawer: React.FC<MobileSortViewDrawerProps> = ({
    open,
    onClose,
    sortType,
    onSelectSortType,
    typeFilter,
    onSelectTypeFilter,
    onDone,
}) => {
    return (
        <MobileBottomDrawer open={open} onClose={onClose} title="Sort & View">
            <Box sx={{ display: 'flex', flexDirection: 'column', pb: 1 }}>
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        py: 1,
                    }}
                >
                    Sort By
                </Typography>
                <RadioGroup
                    value={sortType}
                    onChange={(event) =>
                        onSelectSortType(event.target.value as SortType)
                    }
                >
                    <FormControlLabel
                        value={SortType.None}
                        control={<Radio />}
                        label={label('None')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                    <FormControlLabel
                        value={SortType.AZ}
                        control={<Radio />}
                        label={label('A-Z')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                    <FormControlLabel
                        value={SortType.ZA}
                        control={<Radio />}
                        label={label('Z-A')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                </RadioGroup>
                <Divider sx={{ my: 1 }} />
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        py: 1,
                    }}
                >
                    View
                </Typography>
                <RadioGroup
                    value={typeFilter}
                    onChange={(event) =>
                        onSelectTypeFilter(event.target.value as TypeFilter)
                    }
                >
                    <FormControlLabel
                        value={TypeFilter.All}
                        control={<Radio />}
                        label={label('All')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                    <FormControlLabel
                        value={TypeFilter.Premium}
                        control={<Radio />}
                        label={label('Premium')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                    <FormControlLabel
                        value={TypeFilter.Free}
                        control={<Radio />}
                        label={label('Free')}
                        labelPlacement="start"
                        sx={{
                            m: 0,
                            minHeight: 48,
                            justifyContent: 'space-between',
                        }}
                    />
                </RadioGroup>
                <Box
                    sx={{
                        position: 'sticky',
                        bottom: 0,
                        pt: 2,
                        pb: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
                        bgcolor: 'background.paper',
                    }}
                >
                    <Button
                        onClick={onDone}
                        variant="contained"
                        size="medium"
                        fullWidth
                    >
                        Done
                    </Button>
                </Box>
            </Box>
        </MobileBottomDrawer>
    );
};

export default MobileSortViewDrawer;
